module.exports = __webpack_public_path__ + "static/media/fa-regular-400.0b5e3a54.woff";